import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CourseDataTable, CourseTableLabels } from '../../models/types';
import { Company, CompanyEnum } from '../../models/company.model';
import { LowerCasePipe, NgForOf, NgIf } from '@angular/common';
import { PricePipe } from '@lx/shared/ui/pipes';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-course-table',
  imports: [TableModule, NgForOf, NgIf, PricePipe, LowerCasePipe],
  templateUrl: './course-table.component.html',
  styleUrls: ['./course-table.component.scss'],
})
export class CourseTableComponent {
  @Input() data: CourseDataTable[] | undefined;
  @Input() columnLabels: CourseTableLabels | undefined;
  @Input() company: Company = CompanyEnum.KIL;
  @Input() notationMarks: Record<string, string> | undefined;
}
